export enum Carrier {
  DPD = 'dpd',
  DHL = 'dhl',
  DHL_GO_GREEN = 'dhlGoGreen',
  DIE_POST = 'diePost',
}
